export default {
  userAgent: {},
  router: {}
};
